import React from 'react';
import { PropTypes as PT } from 'prop-types';
import PSTNListItem from 'components/PSTN/PSTNListItem';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import dropdownNavigation from 'components/Dropdown/DropdownNavigation';
import ReactDOM from 'react-dom';
import _map from 'lodash/map';
import classes from './PSTN.module.scss';

const ELEMENT_HEIGHT = 30;

class PSTNSearchResults extends React.Component {
  UNSAFE_componentWillUpdate(nextProps) {
    if (nextProps.selectionIndex > this.props.selectionIndex) {
      this.scrollToNextResult();
    }

    if (nextProps.selectionIndex < this.props.selectionIndex) {
      this.scrollToPreviousResult();
    }
  }

  /* eslint-disable react/no-find-dom-node */
  getScrollTop = () => ReactDOM.findDOMNode(this).scrollTop;

  setScrollTop = (scrollTop) => {
    ReactDOM.findDOMNode(this).scrollTop = scrollTop;
  };
  /* eslint-enable react/no-find-dom-node */

  scrollToNextResult = () => {
    const highlightedIndex = this.props.selectionIndex + 2;
    if (highlightedIndex * ELEMENT_HEIGHT > this.getScrollTop() + this.props.maxItems * ELEMENT_HEIGHT) {
      this.setScrollTop((highlightedIndex - this.props.maxItems) * ELEMENT_HEIGHT);
    }
  };

  scrollToPreviousResult = () => {
    const highlightedIndex = this.props.selectionIndex - 1;
    if (highlightedIndex * ELEMENT_HEIGHT < this.getScrollTop()) {
      this.setScrollTop(highlightedIndex * ELEMENT_HEIGHT);
    }
  };

  render() {
    const { searchResults, selectCountry, searchString, selectionIndex } = this.props;
    let returnArray = [];

    const emptyState = searchString && !searchResults.length;
    if (searchResults.length) {
      let index = -1;
      returnArray = _map(searchResults, (result) => {
        index += 1;
        return (
          <div key={`${result.countryCode}${index}`}>
            <PSTNListItem country={result} selectCountry={selectCountry} isHighlighted={index === selectionIndex} />
          </div>
        );
      });
    } else if (emptyState) {
      returnArray = <EmptyMessage />;
    }

    return <div className={classes.infiniteScroll}>{returnArray}</div>;
  }
}

PSTNSearchResults.propTypes = {
  searchResults: PT.array,
  maxItems: PT.number,
  searchString: PT.string,
  selectCountry: PT.func.isRequired,
  selectionIndex: PT.number
};

export default dropdownNavigation(PSTNSearchResults);
